export default "__VITE_ASSET__vHacBFB1__"